import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import {
    client,
    BrightcoveSettings,
    InteractSettings,
    SimuliveSettings,
    Stream2Settings,
    StreamSettings,
    VimeoSettings,
    YoutubeSettings,
    UltimateSettings,
    ExternalSettings,
    HlsSettings,
} from '../index';

export type FetchVirtualSessionResponse =
    | null
    | StreamSettings
    | Stream2Settings
    | InteractSettings
    | YoutubeSettings
    | VimeoSettings
    | SimuliveSettings
    | UltimateSettings
    | BrightcoveSettings
    | ExternalSettings
    | HlsSettings;

export async function fetchVirtualSession<
    Response extends FetchVirtualSessionResponse = FetchVirtualSessionResponse
>(eventId: number, sessionId: number, shouldSendCheckin = false) {
    return (
        await client().get<Response>(
            `/api/v2/agenda/events/${eventId}/sessions/${sessionId}/virtualSession?checkIn=${shouldSendCheckin}`
        )
    ).data;
}

const useVirtualSession = <
    Response extends FetchVirtualSessionResponse = FetchVirtualSessionResponse
>({
    eventId,
    sessionId,
    shouldSendCheckin = false,
    options = {},
}: {
    eventId: number;
    sessionId: number;
    shouldSendCheckin?: boolean;
    options?: UseQueryOptions<Response, AxiosError>;
}) => {
    return useQuery<Response, AxiosError>(
        ['virtualSession', eventId, sessionId, shouldSendCheckin],
        () => fetchVirtualSession(eventId, sessionId, shouldSendCheckin),
        {
            retry: 0,
            enabled: !!eventId && !!sessionId,
            ...options,
        }
    );
};

export default useVirtualSession;
